<template>
  <v-container class="component_main">
    <v-row v-show="showList" class="px-3">
      <!-- <div class="col-xs-12 col-sm-12 col-md-12 pa-0"> -->
        <ExtractFilter
          :formatDate="(date) => formatDate(date)"
          :headers="headers"
          :operadoras="operadoras"
          :parseDate="(date) => parseDate(date)"
          :dataReferencia="dataReferencia"
          :statusSolicitacaoList="statusSolicitacaoList"
          :tipoguiasList="tipoguiasList"
          :filter="(filter) => updateFilter(filter)"
        />
      <!-- </div>
      <div class="col-xs-12 col-sm-12 col-md-12 pa-0"> -->
        <ExtractList
          :getFile="(tipo) => getFile(tipo)"
          :getList="(page) => getList(filter, page)"
          :headers="headers"
          :list="list"
          :listOperadora="listOperadora"
          :pagination="pagination"
          :selectItem="(item, action) => selectItem(item, action)"
          :statusColors="statusColors"
        />
      <!-- </div> -->
    </v-row>

      <ExtractDetails
      v-show="showExtract"
        :close="()=>selectItem(null, 'close')"
        :details="selectedItem"
        :getFile="(tipo) => getFile(tipo)"
        :listOperadora="listOperadora"
        :statusColors="statusColors"
      />
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import ExtractFilter from "./extrato_de_solicitacao/Filter"
import ExtractList from "./extrato_de_solicitacao/ExtractList"
import ExtractDetails from "./extrato_de_solicitacao/ExtractDetails"
export default {
  components: {
    ExtractFilter,
    ExtractList,
    ExtractDetails,
  },
  data() {
    return {
      dataReferencia: null,
      filter: null,
      headers: [
        { text: "Data Hora", align: "start", value: "req_datasolicitacao", sortable: false },
        { text: "Operadora", value: "operadora_id", sortable: false },
        { text: "Tipo guia", value: "TipoGuia", sortable: false },
        { text: "N° guia", value: "res_guiaprestador", sortable: false },
        { text: "N° guia oper.", value: "res_guiaoperadora", sortable: false },
        { text: "Cart. beneficiário", value: "req_benef_carteira", sortable: false },
        { text: "Nome beneficiário", value: "req_benef_nome", sortable: false },
        { text: "Status", value: "dom_statussolicitacao_descricao", sortable: false },
      ],
      list: [],
      operadoras: [],
      prestadores:[],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
      },
      showList: true,
      showExtract: false,
      selectedItem: {},
      statusColors: {
        "-1": "#979797",
        0: "#979797",
        1: "#32B88B",
        2: "#FC9D0A",
        3: "#D0021B",
        4: "#D0021B",
        5: "#FC5F17",
        6:"#4A4A4A",
        7: "#B2B842",
        
      },
      statusSolicitacaoList: [],
      tipoguiasList: []
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      modules: (state) => state.userData.modules,
      listOperadora: (state) => state.permissions.operadoras
    }),
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
    this.getTipoGuias()
    this.getStatusSolicitacao()
    this.$store.dispatch("permissions/getOperadoras" , {grupo_economico: this.grupoEconomico, modulo_operadora: "autorizador"}).then(list=> {
      this.operadoras = list
    }) 
  },
  // watch:{
  //   operadoras:{
  //     deep: true,
  //     handler(val){
  //       if (val.length==1) {
  //         this.formData.operadora_ans_id = [this.operadoras[0].id]
  //       } 
  //       else {
  //         this.formData.operadora_ans_id =  this.formData.operadora_ans_id && this.formData.operadora_ans_id.length && this.operadorasFilter?  this.formData.operadora_ans_id.filter(el => this.operadorasFilter.getIndex(item=> item.id== el)>-1 ) : []
  //       }
  //     }
  //    }
  // },
  methods: {
    formatDate(date) {
      if (!date) return null
      if(date.indexOf('T') > -1){
        date = date.split("T")[0]
      }
      const [year, month, day] = date.split("-")
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null
      if(date.indexOf('T') > -1){
        date = date.split("T")[0]
      }
      const [day, month, year] = date.split("/")
      return `${year}-${month}-${day}`
    },
    getFile(tipo){
      let payload, obj
      switch (tipo) {
        case 'csv': 
          payload = this.filter? Object.assign(this.pagination, this.filter) : Object.assign(this.pagination,{ grupo_economico: this.grupoEconomico })
          obj = {
            filename: 'extrato_solicitacoes.csv',
            query: [
              {
                Modulo: "Autorizador",
                Acao: "getcsvsolicitacoes",
                Payload: payload,
              },
            ],
          }
        break
        case 'req':
        case 'res':
          payload = { 
            grupo_economico: this.grupoEconomico,
            transacao_id: this.selectedItem.transacao_id,
            tipo: tipo
          }
          obj = {
            filename: tipo== 'req'? `solicitacao_prestador_${this.selectedItem.res_guiaprestador}.xml`: `resposta_operadora_${this.selectedItem.res_guiaoperadora}.xml`,
            query: [
              {
                Modulo: "Autorizador",
                Acao: "getdocsolicitacao",
                Payload: payload,
              },
            ],
          }
         
      }
      this.$store.dispatch("request/getFile", obj)
    },
    getTipoGuias() {
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "gettipoguias",
            Payload: { grupo_economico: this.grupoEconomico, modulo_guia: "autorizador"},
            noLoader: true
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.tipoguiasList = response.dados
        this.tipoguiasList.unshift({id: null, descricao: "Selecione"})
      })
    },
    getStatusSolicitacao(){
       let obj = {
        query: [
          {
            Modulo: "Autorizador",
            Acao: "getstatussolicitacao",
            Payload: { grupo_economico: this.grupoEconomico},
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.statusSolicitacaoList = response.dados
        this.statusSolicitacaoList.unshift({id: null, descricao: "Selecione"})
      })

    },
    getList(filter, page) {
      this.dataReferencia = null
      this.pagination.offset = page? page : 1
      let payload = filter? Object.assign(this.pagination, filter) : Object.assign(this.pagination,{ grupo_economico: this.grupoEconomico }) // this.grupoEconomico}
      let obj = {
        query: [
          {
            Modulo: "Autorizador",
            Acao: "getextratosolicitacoes",
            Payload: payload,
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        let { dados, total_pages, current_page, data_inicio, data_final } = response
        this.list = dados
        this.pagination.total_pages = total_pages
        this.pagination.offset = current_page
        this.pagination.current_page = current_page
        this.dataReferencia = { data_inicio, data_final }
        this.showList = true
      })
    },
    updateFilter(filter) {
      this.filter = filter
      this.getList(filter)
    },
    selectItem(item, action) {
      let select = Object.assign({}, item)
      this.selectedItem = select
      switch (action) {
        case "toggleStatus":
          this.showList = false
          this.showExtract = true
          break
          case "close":
          this.showList = true
          this.showExtract = false
          break
        default:
          break
      }
    }
  },
}
</script>
